'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { siteLinks, currentSection } from '@/lib/site-navigation.mjs';

const SideMenu = () => {
  const pathname = usePathname() ?? '/';
  const active = currentSection(pathname);
  return (
    <nav className="site-header" aria-label="Main navigation" data-site-header>
      <Link href="/" className="site-header__home">
        genproof.com
      </Link>
      <div className="site-header__links">
        {siteLinks().map(({ href, label }) => (
          <Link key={href} href={href} aria-current={active === href ? 'page' : undefined}>
            {label}
          </Link>
        ))}
      </div>
    </nav>
  );
};

export default SideMenu; 
